export const selectAllHighscores = (state) => state.highscores.allHighscores;
